import React from 'react';
import { 
  PhoneIcon, 
  EnvelopeIcon,
  ChatBubbleOvalLeftEllipsisIcon,
  HeartIcon,
  GlobeAltIcon
} from '@heroicons/react/24/outline';

const ContactSupport = () => {
  const handleEmailClick = () => {
    window.location.href = 'mailto:marketing@npontu.com?subject=Support Request from Snwolley WhatsApp Platform';
  };

  const handlePhoneClick = () => {
    window.location.href = 'tel:+233556541525';
  };

  const socialMediaLinks = [
    {
      platform: 'Facebook',
      url: 'https://web.facebook.com/p/Npontu-Technologies-61560373513352/',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      )
    },
    {
      platform: 'Instagram',
      url: 'https://www.instagram.com/npontu_technologiesltd/',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 6.62 5.367 11.987 11.988 11.987c6.62 0 11.987-5.367 11.987-11.987C24.014 5.367 18.637.001 12.017.001zM8.449 16.988c-1.297 0-2.448-.73-3.016-1.804C4.967 14.626 4.747 13.999 4.747 13.999s.22-.627.686-1.185c.558-1.074 1.719-1.804 3.016-1.804s2.448.73 3.016 1.804c.466.558.686 1.185.686 1.185s-.22.627-.686 1.185C10.897 16.258 9.746 16.988 8.449 16.988zM15.017 12.013c0-1.658-1.342-3-3-3s-3 1.342-3 3s1.342 3 3 3S15.017 13.671 15.017 12.013zM18.017 6.987c-.276 0-.5-.224-.5-.5s.224-.5.5-.5s.5.224.5.5S18.293 6.987 18.017 6.987z"/>
        </svg>
      )
    },
    {
      platform: 'LinkedIn',
      url: 'https://www.linkedin.com/company/npontu-technology/',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
      )
    },
    {
      platform: 'TikTok',
      url: 'https://www.tiktok.com/@npontutechnologiesltd',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
        </svg>
      )
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <ChatBubbleOvalLeftEllipsisIcon className="h-16 w-16 text-blue-600 mx-auto mb-4" />
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Contact Support
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            We're here to help! Reach out to us through any of the channels below and our team will get back to you as soon as possible.
          </p>
        </div>

        {/* Contact Methods */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {/* Email */}
          <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
            <div className="flex items-center mb-4">
              <EnvelopeIcon className="h-8 w-8 text-blue-600 mr-3" />
              <h2 className="text-2xl font-semibold text-gray-900">Email Us</h2>
            </div>
            <p className="text-gray-600 mb-4">
              Send us an email and we'll respond within 24 hours.
            </p>
            <button
              onClick={handleEmailClick}
              className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium"
            >
              marketing@npontu.com
            </button>
          </div>

          {/* Phone */}
          <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
            <div className="flex items-center mb-4">
              <PhoneIcon className="h-8 w-8 text-green-600 mr-3" />
              <h2 className="text-2xl font-semibold text-gray-900">Call Us</h2>
            </div>
            <p className="text-gray-600 mb-4">
              Speak directly with our support team during business hours.
            </p>
            <button
              onClick={handlePhoneClick}
              className="bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-colors font-medium"
            >
              +233 556541525
            </button>
          </div>
        </div>

        {/* Social Media */}
        <div className="bg-white rounded-lg shadow-md p-8">
          <div className="text-center mb-8">
            <GlobeAltIcon className="h-12 w-12 text-purple-600 mx-auto mb-4" />
            <h2 className="text-3xl font-semibold text-gray-900 mb-2">
              Follow Us on Social Media
            </h2>
            <p className="text-gray-600">
              Stay connected and get the latest updates from Npontu Technologies
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {socialMediaLinks.map((social) => (
              <a
                key={social.platform}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-col items-center p-4 rounded-lg border-2 border-gray-200 hover:border-blue-500 hover:bg-blue-50 transition-all group"
              >
                <div className="text-gray-600 group-hover:text-blue-600 transition-colors mb-2">
                  {social.icon}
                </div>
                <span className="text-sm font-medium text-gray-700 group-hover:text-blue-700">
                  {social.platform}
                </span>
              </a>
            ))}
          </div>

          <div className="text-center mt-8">
            <div className="text-gray-600 space-y-1">
              <p>Instagram & TikTok: <span className="font-semibold text-gray-900">@npontu_technologiesltd</span></p>
              <p>LinkedIn: <span className="font-semibold text-gray-900">@npontu-technology</span></p>
            </div>
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-12 text-center">
          <div className="bg-blue-50 rounded-lg p-6">
            <HeartIcon className="h-8 w-8 text-red-500 mx-auto mb-3" />
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Thank you for choosing Snwolley!
            </h3>
            <p className="text-gray-600">
              Your feedback and questions help us improve our WhatsApp automation platform. 
              We're committed to providing you with the best possible experience.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSupport;